import { useState } from "react";
import { getProfilePictureURL } from "../../firebase/storage/ProfileFunctions";
import { AccountView, nameofAccountSchemaDOB, nameofAccountSchemaEmail, nameofAccountSchemaFirstName, nameofAccountSchemaLastName, nameofAccountSchemaMiddleName, nameofAccountSchemaPhoneNumber } from "../../firestore/Types/AccountSchema";
import { ProfileImage } from "../Common/ProfileImage";
import { Textbox } from "../Common/Textbox";

export function ViewAccount({ account }: { account: AccountView }) {
    const [fileName, setFileName] = useState("");

    getProfilePictureURL(account.Id).then((url) => {
        if (url) {
            setFileName(url);
        }
    }).catch(() => {});

    return (
        <div className="section-box p-4">
            <div className="flex flex-row">
                <h3 className="section-title">Personal Details</h3>
            </div>
            <div className="items-center sm:flex xl:block 2xl:flex sm:space-x-4 xl:space-x-0 2xl:space-x-4">
                <ProfileImage profilePicture={fileName} />
            </div>
          
            <Textbox label={"First Name"} name={nameofAccountSchemaFirstName} value={account.FirstName} isReadonly={true}></Textbox>
            <Textbox label={"Middle Name"} name={nameofAccountSchemaMiddleName} value={account.MiddleName ?? ""} isReadonly={true}></Textbox>
            <Textbox label={"Last Name"} name={nameofAccountSchemaLastName} value={account.LastName} isReadonly={true}></Textbox>
            <Textbox label={"Email"} name={nameofAccountSchemaEmail} value={account.Email} isReadonly={true}></Textbox>
            <Textbox label={"Phone"} name={nameofAccountSchemaPhoneNumber} value={account.PhoneNumber} isReadonly={true}></Textbox>
            <Textbox label={"DOB"} name={nameofAccountSchemaDOB} value={account.DOB} isReadonly={true}></Textbox>
        </div>
    );
}